export const errorCode = new Map([
  [
    undefined,
    {
      msg: '无错误code',
      notSendAPIs: [
        '/payment/wechat/weiXinQr',
        '/payment/wechat/weiXinH5',
        '/payment/wechat/notify/weiXinQrLoop',
        '/data_collection',
      ],
    },
  ],
  // /product/commodity/subscribeArrivalNotice的 -1是请求频繁，后端设置错错误码
  [
    -1,
    {
      msg: '系统异常',
      notSendAPIs: [
        '/stable/diffusion/getAiPictureResult',
        '/stable/diffusion/aiPicture',
        '/product/commodity/subscribeArrivalNotice',
      ],
    },
  ],
  [1, { msg: '不是商城的用户，权限拒绝' }],
  [2, { msg: '参数无效' }],
  // /store/reseller/info/getResellerInfo
  [30007, { msg: '分销码无效' }],
  // /store/trade/coupon/use
  [21104, { msg: '交易码未找到' }],
  [21403, { msg: '无效的优惠券' }],
  [21105, { msg: '无效的交易码' }],
  [21412, { msg: '游客使用绑定优惠券需登陆' }],
  [21425, { msg: '优惠券无法与折扣叠加使用' }],
  [21426, { msg: '代金券券无法与折扣叠加使用' }],
  // /infr-user-service/account/v2/signin
  [1001, { msg: '账户不存在' }],
  [1002, { msg: '密码错误' }],
  [
    10001,
    {
      msg: '请求过于频繁，稍后再试',
      notSendAPIs: [
        '/store/user/subscribe/submitSubscribe',
        '/product/commodity/subscribeArrivalNotice',
        '/insurance/service/checkSerial',
        '/data_collection',
        // '/store/reseller/',
      ],
    },
  ],
  [23001, { msg: '税费获取失败' }],
  [23007, { msg: '地址解析失败' }],
  [21201, { msg: '不允许订单操作' }],
  [21411, { msg: '无效的优惠券' }],
  [21212, { msg: '订单所属账户不匹配' }],
  [21414, { msg: '无效的优惠额，取最低优惠为现价' }],
  [40005, { msg: '参数不合法异常' }],
  [21407, { msg: '优惠券没有使用次数' }],
  [50001, { msg: '无效的设备序列号' }],
  [50002, { msg: '不是相机或者设备不存在' }],
  [50003, { msg: '不是该机型的序列号' }],
  [50004, { msg: '超过绑定时间' }],
  [50005, { msg: '设备已经绑定增值服务' }],
  [50008, { msg: '非商城购买的设备且不存在购买时间' }],
  [70001, { msg: '重复订阅' }],
  [80001, { msg: '入参非法' }],
  [100005, { msg: '基础参数非法' }],
  [21000, { msg: '产品未找到' }],
  [13005, { msg: '用户未订阅' }],
  [12001, { msg: '当前用户不存在配件折扣权益' }],
  [12002, { msg: '权益额度已用完' }],
  [100005, { msg: '基础参数非法' }],
  [21000, { msg: '产品未找到' }],
  [16001, { msg: '重复购买云服务' }],
  [215016, { msg: '订阅模式不包含云商品' }],
  [90023, { msg: '订单埋点状态已经变更过了' }],
  [16017, { msg: '订阅续费周期不匹配，场景eg：续费前24H内不能重启续订' }],
  [16018, { msg: '订阅过期时间不匹配，场景eg：还有5MIN就到期了，不能重新更新支付信息' }],
  [16019, { msg: '取消订阅限制异常，场景eg：支付处理中，不能取消订阅' }],
  [16009, { msg: '云服务订阅记录不存在' }],
  [5000, { msg: 'VB订阅-该邮箱或手机号已经订阅' }],
  [3001, { msg: 'VB订阅-操作过于频繁，请稍后重试！' }],
]);

// 不发飞书消息
export const notSendErrCode = new Set([
  undefined,
  0,
  1,
  2,
  30007,
  21104,
  21105,
  21425,
  21407,
  1001,
  1002,
  50001,
  50002,
  50003,
  21000,
  50004,
  50005,
  50008,
  70001,
  21212,
  21414,
  21412,
  21411,
  21403,
  21426,
  13005,
  13006,
  12001,
  12002,
  90023,
  16001,
  16009,
  23007,
  23001,
  5000,
  3001,
]);

export const notSendApis = ['open.feishu.cn/open-apis/', '/stable/diffusion']; // '/data_collection',
